import $ from 'jquery';
import axios from 'axios';
import type from './libs/type';

let $page = $('.product');
let $slider = $page.find('.product-slider');
let $sliderImageWrapper = $slider.find('.product-slider__image-wrapper');
let $sliderImage = $slider.find('.product-slider__image');
let $sliderNavigation = $slider.find('.product-slider__preview__navigation');

const initPreviewSlider = function() {
    $sliderNavigation.on('click', '.product-slider__preview__item', function(e) {
        e.preventDefault();

        if($(this).hasClass('_active')) {
            return;
        }

        let previewImageUrl = $(this).data('preview-url');
        let fullHDImageUrl = $(this).attr('href');

        if(previewImageUrl || fullHDImageUrl) {
            $sliderImage.attr('src', previewImageUrl || fullHDImageUrl);

            if(fullHDImageUrl) {
                $sliderImageWrapper.attr('href', fullHDImageUrl)
            }

            $(this).parent().find('.product-slider__preview__item._active').removeClass('_active');
            $(this).addClass('_active');
        }
    })
}

const init = function()
{
    initPreviewSlider();

    $('body').on('click', '.product__faq__item__title', function() {
        $(this).parent().toggleClass('_opened');
    })
}

export default init;